import { Injector, Component, Renderer2 } from '@angular/core';
import { ComponentBase } from './component.base';
import { PageInterface } from './page.interface';
import { ContextApplication } from 'src/app/Context/contextapplication/contextapplication';
import { PoNotificationService } from '@po-ui/ng-components';
import { APISCockpit } from 'src/service/apis-cockpit';
import { LoginService } from 'src/app/Home/login/login.service';

/**
 * @description
 *
 * Página básica
 */

@Component({
    template: '',
    standalone: false
})

export abstract class PageBase extends ComponentBase implements PageInterface {

	/**
	 * Título da página
	 */
	public title: string;

	public loginService: LoginService;
	public contextApplication: ContextApplication;
	public poNotification: PoNotificationService;
	public apiscockpit: APISCockpit;
	public renderer2: any;

	constructor(public objInjector: Injector) {
		super(objInjector);
		this.apiscockpit = objInjector.get(APISCockpit);
		this.loginService = objInjector.get(LoginService);
		this.contextApplication = objInjector.get(ContextApplication);
		this.poNotification = objInjector.get(PoNotificationService);
		this.renderer2 = objInjector.get(Renderer2);
	}

	ngOnInit(): void {
		super.ngOnInit();
		super.changeLanguageBase(this.contextApplication);
	}

	abstract onReceiveLiterals();

	ngOnDestroy(): void {
		super.ngOnDestroy();
	}

}
